import React from "react";
import Skeleton, { SkeletonBlock } from "../ui/Skeleton";

/** Readable-register loading placeholder for host dashboard. */
export default function DashboardLoadingSkeleton({ label = "Loading guest list…" }) {
  return (
    <div className="min-h-screen bg-canvas max-w-page mx-auto px-4 pt-5 pb-6" aria-busy="true" aria-label={label}>
      <Skeleton label={label} className="space-y-6">
        <div className="flex items-center justify-between gap-2">
          <SkeletonBlock className="h-11 w-28" />
          <div className="flex gap-2">
            <SkeletonBlock className="h-11 w-24" />
            <SkeletonBlock className="h-11 w-32" />
          </div>
        </div>
        <SkeletonBlock className="h-10 w-3/4 max-w-sm" />
        <SkeletonBlock className="h-5 w-full max-w-md" />
        <div className="flex gap-2 flex-wrap">
          {[1, 2, 3].map((i) => (
            <SkeletonBlock key={i} className="h-11 w-24" />
          ))}
        </div>
        <div className="space-y-3 pt-2">
          <SkeletonBlock className="h-5 w-40" />
          <SkeletonBlock className="h-2 w-full max-w-md" />
          {[1, 2, 3, 4].map((i) => (
            <SkeletonBlock key={i} className="h-[68px]" />
          ))}
        </div>
      </Skeleton>
    </div>
  );
}
